export default __webpack_public_path__ + "static/media/learose4-768w.42c26125.png";